import { forwardRef, type HTMLAttributes, type ReactNode } from "react";
import { cn } from "../../lib/cn.js";

export type TintColor =
	| "indigo"
	| "amber"
	| "success"
	| "pink"
	| "info"
	| "violet"
	| "teal"
	| "warning"
	// Уникальные акценты инструментов (различимые hue) — см. section-icons.ts.
	| "rose"
	| "emerald"
	| "yellow"
	| "blue"
	// Направления каталога, разведённые с золотом бренда (см. tokens.css).
	| "terracotta"
	| "plum";
export type TintSize = "sm" | "md" | "lg" | "xl";

export interface TintTileProps extends HTMLAttributes<HTMLDivElement> {
	tint: TintColor;
	size?: TintSize;
	icon: ReactNode;
}

/** Маппинг tint → CSS-utility класс (выставляет background + color плитки). */
export const TINT_CLASS: Record<TintColor, string> = {
	indigo: "tint-indigo",
	amber: "tint-amber",
	success: "tint-success",
	pink: "tint-pink",
	info: "tint-info",
	violet: "tint-violet",
	teal: "tint-teal",
	warning: "tint-warning",
	rose: "tint-rose",
	emerald: "tint-emerald",
	yellow: "tint-yellow",
	blue: "tint-blue",
	terracotta: "tint-terracotta",
	plum: "tint-plum",
};

const sizeClasses: Record<TintSize, string> = {
	sm: "size-6 rounded-md",
	md: "size-8 rounded-md",
	lg: "size-10 rounded-lg",
	xl: "size-12 rounded-xl",
};

/** TintTile — цветная плитка-подложка под Tabler-иконку (предмет, AI-блок, recommendation). */
export const TintTile = forwardRef<HTMLDivElement, TintTileProps>(
	({ tint, size = "md", icon, className, ...props }, ref) => (
		<div
			ref={ref}
			className={cn(
				"inline-flex items-center justify-center shrink-0",
				sizeClasses[size],
				TINT_CLASS[tint],
				className,
			)}
			{...props}
		>
			{icon}
		</div>
	),
);
TintTile.displayName = "TintTile";
